export default __webpack_public_path__ + "static/media/high-speed_connector.cfba4f66.png";